module.exports = __webpack_public_path__ + "img/mastercard.c92a4da0.svg";